import { Controller } from 'stimulus';
import Sticky from 'sticky-js';

class MemberController extends Controller {
  connect() {
    this.overviewTogglerSelector = '.js-member-overview-toggler';
    const sticky = new Sticky(this.overviewTogglerSelector);

    sticky.options = {
      stickyFor: 992,
      marginTop: 100,
    };
  }

  onTogglerClick() {
    this.toggleOverview();
  }

  toggleOverview() {
    document.querySelector('body').classList.toggle('member-overview-open');
    this.overviewTarget.classList.toggle('is-open');
  }
}

MemberController.targets = [
  'overview',
];

export default MemberController;
